export const GRETA_AI_CHAT_PROJECTS_SKELETON_WIDTHS = ['72%', '56%']

export const QA_NAME_GRETA_AI_CHAT_PROJECTS_SKELETON =
  'gretaAIChatProjectsSkeleton'
